import { useSelectedTeam } from "features/team-settings/hooks";

export const useDataInsightsFlag = (): {
  enabled: boolean;
  isLoading: boolean;
} => {
  const { selectedTeam, isDataInsightsEnabled } = useSelectedTeam();
  const isLoading = selectedTeam === undefined;

  return { enabled: isDataInsightsEnabled, isLoading };
};
